import { AppSidebar } from '@/components/app-sidebar'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { Outlet } from 'react-router-dom'

export default function DashboardLayout() {
  return (
    <>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute top-2 left-4 text-xl z-50 text-white bg-ss-blue-700 font-bold p-6 rounded shadow"
      >
        Skip to main content
      </a>
      <main tabIndex={-1} aria-label="Dashboard Main Content">
        <SidebarProvider
          className="overflow-auto"
          // className="bg-[url(/auth/dashboard-bg.png)] bg-no-repeat bg-cover"
          style={
            {
              '--sidebar-width': 'calc(var(--spacing) * 72)',
              '--header-height': 'calc(var(--spacing) * 12)',
            } as React.CSSProperties
          }
        >
          <div className="flex items-center w-full">
            <AppSidebar />
            <SidebarInset className="rounded-none lg:rounded-xl m-0 lg:m-2.5 min-h-[calc(100vh-30px)]">
              <div className="flex flex-1 flex-col">
                <Outlet />
              </div>
            </SidebarInset>
          </div>
        </SidebarProvider>
      </main>
    </>
  )
}
